import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import React from "react";
import { IPurchaseOrders } from "../../interfaces/PurchaseOrder/IPurchaseOrder"
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, SubmitHandler } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import SupportIcon from '@mui/icons-material/ContactSupport';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { ICrew } from "../../interfaces/ICrew";
import { IUser } from "../../interfaces/IUser";
import { ITray } from "../../interfaces/ITray";
import { IApplication } from "../../interfaces/IApplication";
import { setPageTitle } from "../../slices/applicationSlice";
import { useAppDispatch } from "../../hooks";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useNavigate } from "react-router-dom";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchChips from "../../components/SearchChips";
import moment from "moment";
import { setPurchaseOrder } from "../../slices/purchaseOrderSlice";
import { setPurchaseOrderDetail, setPurchaseOrderDetails } from "../../slices/purchaseOrderDetailSlice";
import { ISearchChips } from "../../interfaces/Core/ISearchChips";
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";



const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface IFormInput {
  Name: string
  Type: string
  Crew: string
}

const resolver: Resolver<IFormInput> = async (values) => {
  return {
    values: values.Name ? values : {},
    errors: !values.Name
      ? {
        Name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

const steps = ['Patching List Management', 'Select Trays'];

export default function PoRecords() {

  function POClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    handlePoOpen();
  }

  function DownloadClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  let navigate = useNavigate();
  const handlePoOpen = () => {
    navigate('/po/PoOrder')
    // setPoOpen(true);
  };

  const buttons = [
    <ActionButton action={POClicked} buttonLabel="ADD NEW PO" />,
    <ActionButton action={DownloadClicked} buttonLabel="DOWNLOAD REPORT" />,
    
  ];


  const dispatch = useAppDispatch();

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    dispatch(setPurchaseOrder(x.row))
    console.log("PO DETAILS", x.row);
    if (x.row.purchaseOrderDetails != null) {
      if (x.row.item == 'item') {
        dispatch(setPurchaseOrderDetails(x.row.purchaseOrderDetails));
      } else {
        dispatch(setPurchaseOrderDetail(x.row.purchaseOrderDetails[0]))
      }
    }

    navigate('/po/PoOrder')
  }

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Purchase Orders",
      backgroundPath: "/assets/images/patchingbg.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  interface IWeek {
    id: number,
    name: string
  }

  const [rows, setRows] = useState<IPurchaseOrders>([]);
  const [selectedCrew, setSelectedCrew] = useState<ICrew>();
  const [selectedUsers, setSelectedUsers] = useState<IUser[]>([]);
  const [crews, setCrews] = useState<ICrew[]>([]);
  const [users, setUsers] = useState<IUser[]>([]);
  const [currentUser, setCurrentUser] = useState<IUser>();
  const [trays, setTrays] = useState<ITray[]>([]);
  const [currentWeek, setCurrentWeek] = useState<IWeek>();
  const [currentYear, setCurrentYear] = useState<number>();
  const [patchingWeeks, setPatchingWeeks] = useState<IWeek[]>([]);
  const [years, setYears] = useState<number[]>([]);
  const [selectedWeeks, setSelectedWeeks] = useState<IWeek[]>([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/PurchaseOrders`)
      .then(res => {
        setRows(res.data);
      })

    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
      .then(res => {
        setCrews(res.data);
      })

    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Users`)
      .then(res => {
        setUsers(res.data);
      })

    var weeks: Array<IWeek> = [];
    for (let index = 0; index < 52; index++) {
      let pWeek: IWeek = {
        id: index,
        name: `Week ${index}`,
      }
      weeks.push(pWeek);
    }
    setPatchingWeeks(weeks);

    var years: Array<number> = [];
    for (let index = 0; index < 20; index++) {
      let year = new Date().getFullYear();
      years.push(year + index);
    }

    setYears(years);

  }, []);

  useEffect(() => {
    console.log("Selected Crew Changed");
    if (selectedCrew) {
      var users = selectedCrew.userCrews.map(obj => {
        return obj.user!
      });
      if (users) {
        setSelectedUsers(users);
      }
    }
  }, [selectedCrew])

  useEffect(() => {
    console.log("IN CURRENT USER");
    if (currentUser != undefined) {
      if (selectedUsers) {
        let users = [...selectedUsers, currentUser]
        console.log("USERS", users);
        setSelectedUsers(users);
      }
    }
    setCurrentUser(undefined);
  }, [currentUser])

  useEffect(() => {
    if (currentWeek) {
      var weeks = [...selectedWeeks, currentWeek];
      setSelectedWeeks(weeks);
    }
    setCurrentWeek(undefined);

  }, [currentWeek])

  useEffect(() => {
    if (currentYear) {
      // var tempYears = [...years, currentYear];
      // setYears(tempYears);
    }
    setCurrentWeek(undefined);
    setSelectedWeeks([]);


  }, [currentYear])

  useEffect(() => {
    GetPurchaseOrders();
  }, [selectedWeeks])

  const { register, handleSubmit, control, formState: { errors } } = useForm<IFormInput>({ resolver });

  const onSubmit: SubmitHandler<IFormInput> = data => {
    axios.post(`${process.env.REACT_APP_ENDPOINT}/api/PatchingLists`, {
      name: data.Name, generation: data.Type, assignedTo: data.Crew
    }).then((data) => {
      if (data.status === 200) {
        setOpen(false);
      };
    });
  };

  const [helpOpen, setHelpOpen] = React.useState(false);

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  

  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 130 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'status', headerName: 'Status', width: 130 },
    { field: 'location', headerName: 'Location', width: 130, },
    { field: 'patching_week', headerName: 'Patching Week', width: 120, },
    { field: 'patching_year', headerName: 'Patching Year', width: 120, },
    { field: 'projected_completion', headerName: 'Projected Completion', width: 160, },
    { field: 'actual_completion', headerName: 'Actual Completion', width: 150, },
    { field: 'tray_type', headerName: 'Tray Type', width: 90, },
    { field: 'total_classes', headerName: 'Total Classes', width: 110, },
    { field: 'total_trays', headerName: 'Total Trays', width: 90, },
  ];

  // const rows = [
  //   { id: 1, name: 'Snow', status: 'Jon', location: 35, patching_week: 5, patching_year: 10, projected_completion: 'testing' },
  // ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  function GetPurchaseOrders() {

  }

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const handleDelete = (props: IUser) => {
    var users = selectedUsers.filter(obj => {
      return obj.id != props.id
    });
    setSelectedUsers(users);
  };

  const handleWeekDelete = (props: IWeek) => {
    var weeks = selectedWeeks.filter(obj => {
      return obj.id != props.id
    });
    setSelectedWeeks(weeks);
  };

  function LoadTrays() {
    axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Trays`).then(res => {
      setTrays(res.data);
    })
  }

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return false;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const poColumns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 70 },
    {
      field: 'orderDate', headerName: 'Order Date', width: 250, valueFormatter: params =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    { field: 'orderNumber', headerName: 'Order Number', width: 150 },
    {
      field: 'vendor', headerName: 'Vendor', width: 300, valueGetter: (params) => { return params.row.vendor != null ? params.row.vendor.name : "" }
    },
    { field: 'createdby', headerName: 'Created By', width: 250, valueGetter: (params) => { return params.row.user != null ? params.row.user.userName : "" } },
    { field: 'salesOrderNumber', headerName: 'Sales Order Number', width: 200 },
    // { field: 'terms', headerName: 'Terms', width: 200 },
    { field: 'department', headerName: 'Department', width: 200 },
    { field: 'discounts', headerName: 'Discounts', width: 200 },
    { field: 'description', headerName: 'Description', width: 200 },
  ];

  const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

  const handleSearchChips = (searchInformation: ISearchChips) => {
    setSearchInformation(searchInformation);
  }

  return (
    <div>
      <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#101010">
        <ThemeProvider theme={darkTheme}>
          <SearchChips handleSearch={handleSearchChips}></SearchChips>
        </ThemeProvider>

        <Grid item xs={12}>
          <Item>
            <div style={{ height: 'calc(100vh - 156px)', width: '100%' }}>
              <StripedDataGrid
                rows={rows}
                columns={poColumns}
                pageSize={20}
                rowsPerPageOptions={[20]}
                sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
              />
            </div>
          </Item>
        </Grid>
      </Grid>
      <ThemeProvider theme={darkTheme}>
        <div>
          <BootstrapDialog
            onClose={handleHelpClose}
            aria-labelledby="customized-dialog-title"
            open={helpOpen}
          >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
              Need Support?
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
                If you are having issues or have questions, please contact us below.
              </Typography>
              <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
              </Button>
              <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="mailto:bobsmarket@idatp.com" underline="none">
                  <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
              </Button>
            </DialogContent>
          </BootstrapDialog>
        </div>
      </ThemeProvider>
    </div>
  );
}

const patchingListTypes = [
  { label: 'Generation 1', value: 'gen_one' },
  { label: 'Generation 2', value: 'gen_two' },
  { label: 'Manual', value: 'manual' },
  { label: 'Blow Out', value: 'blow_out' },
];